import { render, staticRenderFns } from "./AddFollowRecord.vue?vue&type=template&id=604683f9&scoped=true&"
import script from "./AddFollowRecord.vue?vue&type=script&lang=js&"
export * from "./AddFollowRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604683f9",
  null
  
)

export default component.exports